import { render } from "./FortniteIntegrationReporting.vue?vue&type=template&id=4d5ccdd7&scoped=true"
import script from "./FortniteIntegrationReporting.vue?vue&type=script&lang=js"
export * from "./FortniteIntegrationReporting.vue?vue&type=script&lang=js"

import "./FortniteIntegrationReporting.vue?vue&type=style&index=0&id=4d5ccdd7&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5ccdd7"]])

export default __exports__